module.exports = __webpack_public_path__ + "static/media/02_after.b7f435c6.jpg";